/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react'
import TablePagination from '../../components/TablePagination/TablePagination'
import {KTCard, KTCardBody, KTIcon} from '../../../_websoft/helpers'
import {
  SortingState,
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table'
import LoadingComponent from '../../components/LoadingComponent/LoadingComponent'
import {Link, useNavigate} from 'react-router-dom'
import ExportButton from '../../components/TableExportToExcel/ExportButton'
import TableSearch from '../../components/TableSearch/TableSearch'
import ArtikliDropdown from '../../components/ArtikliDropdown/ArtikliDropdown'
import {ToastContainer} from 'react-bootstrap'
import notifyToast from '../../components/Toast/Toast'
import {deletePaleteIzlazi, getPaleteIzlazi} from '../../api/PaleteIzlazi'
import {TableActionButton} from '../../components/TableActionBtn/TableActionButton'
import {PaleteIzlaziModel, ParamsModelPaleteIzlazi} from '../../models/PaleteIzlaziModel'
import {PaginationModel} from '../../models/PaginationModel'

const PaleteIzlaziLista = () => {
  const [data, setData] = useState<PaleteIzlaziModel[]>([])
  const [loading, setLoading] = useState(true)
  const [pagination, setpagination] = useState<PaginationModel>({
    curPage: 1,
    totalPage: 1,
    perPage: 10,
  })
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [params, setparams] = useState<ParamsModelPaleteIzlazi>({per_page: 10, page: 1})

  const [sorting, setSorting] = useState<SortingState>([])
  const [globalFilter, setGlobalFilter] = React.useState('')

  const updatePage = () => {
    setLoading(true)
    getPaleteIzlazi(params)
      .then((response) => {
        const data = response.data['data']
        setData(data)
        const totalPage = Math.floor(response.data['total'] / response.data['per_page'] + 1)
        setpagination({
          curPage: response.data['current_page'],
          totalPage: totalPage,
          perPage: params.per_page,
        })
      })
      .catch((error) => {
        console.error('Error: ', error)
        notifyToast(false, error)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    updatePage()
  }, [params])

  useEffect(() => {
    const {id} = sorting[0] ?? ''
    data.sort((a, b) => a[id] - b[id])
  }, [sorting])

  const columns = [
    {
      id: 'Id',
      header: 'Id',
      accessorKey: 'ArtPaletaId',
    },
    {
      id: 'Sifra',
      header: 'Sifra',
      accessorKey: 'artikal.ArtSifra',
    },
    {
      id: 'Naziv',
      header: 'Naziv',
      accessorKey: 'artikal.ArtNaziv',
    },
    {
      id: 'ArtPaletaBrojPalete',
      header: 'Broj Palete',
      accessorKey: 'ArtPaletaBrojPalete',
    },

    {
      id: 'Datum',
      header: 'Datum',
      accessorKey: 'ArtPaletaDatum',
    },
    {
      id: 'Pocetno',
      header: 'Početno',
      accessorKey: 'ArtPaletaPocetno',
    },
    {
      id: 'Izlaz',
      header: 'Izlaz',
      accessorKey: 'ArtPaletaIzlaz',
    },
    {
      id: 'Dokument',
      header: 'Dokument / Broj dok',
      accessorFn: (row) => `${row.ArtPaletaIzlaz} ${row.ArtPaletaBrDokumenta}`,
    },
    {
      id: 'Kreirao',
      header: 'Kreirao',
      accessorKey: 'uposlenik.UposlenikImePrezime',
    },
    {
      header: 'Akcija',
      accessorKey: 'Akcija',
      cell: ({row}) => (
        <TableActionButton
          onDelete={() => onDelete(row.original.ArtPaletaId)}
          onEdit={() => {
            onEdit(row.original.ArtPaletaId)
          }}
        />
      ),
    },
  ]
  const table = useReactTable({
    data: data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    state: {
      sorting: sorting,
      globalFilter: globalFilter,
    },
    onGlobalFilterChange: setGlobalFilter,
    getFilteredRowModel: getFilteredRowModel(),
    onSortingChange: setSorting,
  })
  const onDelete = (id) => {
    deletePaleteIzlazi(id)
      .then((response) => {
        notifyToast(true, response)
        setparams({per_page: pagination.perPage, page: pagination.curPage})
      })
      .catch((error) => {
        notifyToast(false, error.data['message'])
      })
  }
  const navigate = useNavigate()

  const onEdit = (rowData) => {
    navigate(`/artikli/palete-izlazi/izmjena/${rowData}`)
  }

  return (
    <KTCard>
      <ToastContainer />
      <KTCardBody className='py-4'>
        <div className='col-3 mb-6'>
          <h3 className="fw-bolder mt-3 mb-3">Odaberi artikal</h3>
          <ArtikliDropdown onChange={(name, value) => setparams({...params, artikal: value})} />
        </div>
        <div className='d-flex justify-content-between'>
          <div data-kt-user-table-toolbar='base'>
            <TableSearch onSearch={(text) => setGlobalFilter(text)} />
          </div>
          <div data-kt-user-table-toolbar='base'>
            <ExportButton table={table} filename={'palete-ulazi'} />
            <Link to='/artikli/palete-izlazi/dodaj'>
              <button type='button' className='btn btn-primary'>
                <KTIcon iconName='plus' className='fs-2' />
                Dodaj
              </button>
            </Link>
          </div>
        </div>
        {loading ? (
          <LoadingComponent />
        ) : (
          <div className='table-responsive mt-3 '>
            <table className='table align-middle table-bordered gy-5 no-footer'>
              <thead>
                {table.getHeaderGroups().map((headerGroup) => (
                  <tr
                    key={headerGroup.id}
                    className='text-start fw-bolder fs-7 text-uppercase gs-0 bg-dark p-2'
                  >
                    {headerGroup.headers.map((header) => (
                      <th
                        className='text-white'
                        key={header.id}
                        onClick={header.column.getToggleSortingHandler()}
                      >
                        {flexRender(header.column.columnDef.header, header.getContext())}
                        {/* @ts-ignore */}
                        {{asc: '🔼', desc: '🔽'}[header.column.getIsSorted() ?? null]}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody className='text-gray-600'>
                {table.getRowModel().rows && table.getRowModel().rows.length > 0 ? (
                  table.getRowModel().rows.map((row) => (
                    <tr key={row.id}>
                      {row.getVisibleCells().map((cell) => (
                        <td key={cell.id}>
                          {flexRender(cell.column.columnDef.cell, cell.getContext())}
                        </td>
                      ))}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7}>
                      <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                        No matching records found
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
        <TablePagination
          updatePage={(page, per_page) => setparams({...params, page: page, per_page: per_page})}
          pagination={pagination}
        />
      </KTCardBody>
    </KTCard>
  )
}

export default PaleteIzlaziLista
